<template>
  <v-container fill-height>
    <v-row align="center">
      <v-col cols="12" offset-md="3" md="6" offset-sm="1" sm="10">
        <v-card class="elevation4">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Вход в приложение</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <p class="text-center">
              <router-link text :to="{ name: 'register' }">
                Вы здесь первый раз? Зарегистрируйтесь!
              </router-link>
            </p>
            <v-form v-model="validLogin" ref="form-traditional">
              <v-text-field
                label="Логин"
                v-model="username"
                required
                id="username"
                :rules="[validation.fieldIsRequired]"
                :error-messages="errors('username')"
                @input="clearErrors"
              />
              <v-text-field
                label="Пароль"
                v-model="password"
                required
                type="password"
                :rules="[validation.fieldIsRequired]"
                :error-messages="errors('password')"
                @input="clearErrors"
                id="password"
              />
            </v-form>
            <p class="text-center">
              <router-link text :to="{ name: 'reset' }">
                Забыли пароль?
              </router-link>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn block dark class="primary" @click="doLogin" id="loginButton">
              Войти
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { stored, store } from '../lib/Utils'
import validation from '../lib/Validation'
import { mapMutations, mapActions } from 'vuex'
export default {
  name: 'Login',
  data() {
    return {
      username: stored('last-username'),
      password: '',
      validLogin: false,
      validation,
      errorsData: []
    }
  },
  methods: {
    doLogin() {
      this.login({ username: this.username, password: this.password }).then(
        () => {
          store('last-username', this.username)
          this.$router.push({ name: 'root' })
        }
      )
    },
    clearErrors() {
      this.errorsData = []
    },
    errors(field) {
      if (Array.isArray(this.errorsData)) {
        return this.errorsData
          .filter(e => {
            return e.field === field
          })
          .map(e => {
            return e.message || e.error
          })
      }
    },
    ...mapMutations(['message']),
    ...mapActions(['request', 'login'])
  }
}
</script>
